<template>
  <v-dialog v-model="dialog" max-width="800">
    <v-card>
      <v-card-text class="pa-7">
        <div v-html="content"></div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EmailContentViewDialog',
  data() {
    return {
      dialog: false,
      content: null,
    }
  },
  created() {
    const model = this
    this.$eventBus.$on('emailContentViewDialog', function (dialog, content) {
      model.dialog = dialog
      model.content = content
      model.loadDocument()
    })
  },
  methods: {
    loadDocument() {},
    close() {
      this.dialog = false
    },
  },
}
</script>
